import { CommonModule } from '@angular/common';
import {
    Component,
    InputSignal,
    OnDestroy,
    OnInit,
    WritableSignal,
    inject,
    output,
    input,
    signal,
    AfterViewInit,
    OutputEmitterRef,
} from '@angular/core';
import {
    IqEventBusBrokerHandler,
    IqEventBusBrokerService,
} from '@dat/iq-event-bus';
import { uniqueId, get } from 'lodash';

type RuleResponseTypes = 'SHOW_ELEMENT';
type SpShowElementResponse = {
    spShowElementId: string;
    type: RuleResponseTypes;
};

@Component({
    selector: 'iq-style-processor-show-element',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-style-processor-show-element.component.html',
    styleUrl: './iq-style-processor-show-element.component.scss',
})
export class IqStyleProcessorShowElementComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    rules: InputSignal<any[]> = input([]);
    ruleOperator: InputSignal<string> = input('AND');

    show: WritableSignal<boolean> = signal(false);
    evaluated: OutputEmitterRef<boolean> = output();
    spShowElementId: string = uniqueId('sp-show-element');
    private _eventBroker: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );
    private _registeredAction: Record<string, IqEventBusBrokerHandler>;

    constructor() {}

    ngOnInit() {
        this.spShowElementId = uniqueId('rule');
    }

    ngAfterViewInit() {
        this._checkRules();
    }

    ngOnDestroy() {
        this._registeredAction
            ? this._eventBroker.unregisterMap(this._registeredAction)
            : null;
    }

    private _checkRules() {
        if (!this.rules()?.length) {
            this.show.set(true);
            this.evaluated.emit(true);
            return;
        }

        this._registeredAction = this._eventBroker.registerMap({
            'type:rules:evaluator:run:success': {
                callback: (eventInfo: SpShowElementResponse) => {
                    this._runRules(eventInfo);
                },
            },
        });

        this._eventBroker.dispatch({
            name: 'type:rules:evaluator:run',
            payload: {
                spShowElementId: this.spShowElementId,
                type: 'SHOW_ELEMENT',
                rules: this.rules(),
                operator: this.ruleOperator(),
            },
        });
    }

    private _runRules(eventInfo: SpShowElementResponse) {
        if (get(eventInfo, 'spShowElementId') !== this.spShowElementId) return;

        const response: Record<RuleResponseTypes, () => any> = {
            SHOW_ELEMENT: () => {
                this.show.set(true);
             
            },
        };

        if (!response[eventInfo.type]) return;

        response[eventInfo.type]?.();
        this.evaluated.emit(true);
    }
}
